export const useDefaultData = ({Helpers}) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormGlobal = {
        idgestion: 0,
        idgestiontipo: 0,
        idcontrato: 0,
        cliente: '',
        dpi: '',
        telefono: '',
        casa: '',
        contrato_dia_pago: '',
        lastPaymentDate: '',
        lastPaymentDateDone: '',
        gestion_nuevo_dia_pago: '',
        costo_alquiler: '',
        gestion_descripcion: '',
        monto_devolucion: '',
        cargos_extras_total: '',
        meses_ampliacion: '',
        legalizacion_monto: 0,
        legalizacion_exoneracion: 0,
        legalizacion_pago: 0,
        deposito_total: '',
        ordinary_total_debt: 0,
        ordinary_total_exemption: 0,
        ordinary_total_paid: 0,
        extraordinary_total_debt: 0,
        extraordinary_total_exemption: 0,
        extraordinary_total_paid: 0,
        expense_total_debt: 0,
        expense_total_exemption: 0,
        expense_total_paid: 0,
        aprobacion_check: 'Pendiente Aprobacion',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        paymentExemptionDetails: [],
        expenseExemptionDetails: [],
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
        { value: 'Devuelto a Gestor', label: 'Devuelto a Gestor' },
    ];

    const defaultFormLegalizationPayment = {
        idmovimiento: '',
        idpago: '',
        idcaja: '',
        idbanco: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_usuario: '',
        movimiento_tipo: '',
        movimiento_monto: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.8',
        movimiento_quetzales: '',
        movimiento_dolares: '',
        movimiento_observaciones: '',
        boleta_numero: '',
        boleta_foto_originalname: '',
        boleta_foto_filename: '',
        boleta_foto_path: '',

        // // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultPaymentExemptionForm = {
        exemptionAmount: ''
    }
    
    const defaultExpenseExemptionForm = {
        exemptionAmount: ''
    }



    return Object.freeze({
        defaultDataModal,
        defaultFormGlobal,
        optionsAprobacionCheck,
        defaultFormLegalizationPayment,
        defaultPaymentExemptionForm,
        defaultExpenseExemptionForm
    })
}